import { createGlobalStyle } from 'styled-components';
import React from 'react';
import * as media from 'lib/media';

const Reboot = createGlobalStyle`
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{margin:0;padding:0}

  html {
    color: ${(props) => props.theme.color.gray};
    background: #fff;
    font: 12px/1.5 "DINMedium",'Microsoft YaHei UI','Microsoft YaHei','Segoe UI','Lucida Grande',Verdana,Arial,Helvetica,sans-serif;
    text-size-adjust:none;
    scroll-behavior:smooth;
  }
  body {
    position: relative;
  }

  a {
    color: ${(props) => props.theme.color.gray};
    text-decoration: none;
    cursor:pointer;

    &:hover {
        color: ${(props) => props.theme.color.grayLight};
    }
  }
  :focus,
  a:active,
  a:hover {
      outline: none;
      text-decoration: none;
  }

  .body,
  .main {
    min-height: 400px;
  }

  #page {
    min-width: 1210px; // 1140 + 70
    //background-color: #f2f2f2;
    max-height: 99999999px;
    //padding-right:70px;
  }

  .flex-auto{
    flex: auto;
  }


.container {
  position: relative;
  margin: 0 auto;
}
.page-media{
  .container{
    width: ${media.width.sm}px;
    ${media.mediaMd}{
      width:${media.width.md}px;
    }
    ${media.mediaLg}{
      width:${media.width.lg}px;
    }
  }
}


.page-live{
  #page{
    min-width:1360px;
  }
  .container {
    position: relative;
    margin: 0 auto;
    width:${media.width.md}px;
    ${media.mediaMd}{
      width:${media.width.md}px;
    }
    ${media.mediaLg}{
      width:${media.width.lg}px;
    }
  }
}

  #page_popup{
    position:absolute;
    width:0;
    height:0;
    left:0;
    top:0;
  }
  #top-header{
    box-sizing: border-box;
  }
  //#main.container{
  //    padding-top:1px;
  //    margin-top:-1px;
  //}
  .body {
    border: solid 1px #e6e6e6;
    border-radius: 4px;
    background-color: #fff;
    margin: 20px -1px;
  }

  .body-hd {
    height: 30px;
    line-height: 30px;
    border-bottom: solid 1px #e6e6e6;
    color: #666;
    font-size: 14px;
    text-indent: 20px;
  }

  .body-hd a {
    color: #666;
  }

  .body-hd a:hover {
    color: #7c55f9;
  }

  .nano .content{
    scroll-behavior: smooth;
  }
  .nano .content:focus {
      outline: none;
  }
`;

export default Reboot;
